(function($) {

    // Get Window Width and Height
    var windowWidth = $(window).outerWidth();
    var windowHeight = $(window).height();

    /* Document ready functions */
    jQuery(document).ready(function ($){

      // Hero slide
      var swiper1 = new Swiper('.hero-slides', {
        loop: true,
        effect: 'fade',
        speed:1200,

        fadeEffect: {
            crossFade: true
          },

        autoplay: {
          delay: 1200,
          disableOnInteraction: false,
        },
      });

    // End ready functions
    });

  })(jQuery);
